/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Commercial_Ad_LabelInputs */



/**
* | output |
* | --- |
* | "Commercial content" |
*
* @param {Ad_Commercial_Ad_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_commercial_ad_label = /** @type {((inputs?: Ad_Commercial_Ad_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Commercial_Ad_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("contenu commercial")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kommerzielle Inhalte")
	if (locale === "it") return /** @type {LocalizedString} */ ("Contenuti commerciali")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Коммерческий контент")
	if (locale === "es") return /** @type {LocalizedString} */ ("Contenido comercial")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("商业内容")
	if (locale === "ja") return /** @type {LocalizedString} */ ("商用コンテンツ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वाणिज्यिक सामग्री")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Conteúdo comercial")
	return /** @type {LocalizedString} */ ("Commercial content")
});